import React, { FC, useCallback, useEffect, useState, useRef } from 'react'

interface Props {
  amount: number
  isSlow?: boolean
  isVerySlow?: boolean
}

const TickUpNumber: FC<Props> = ({
  amount,
  isSlow = false,
  isVerySlow = false,
}) => {
  const [timeElapsed, setTimeElapsed] = useState(0)

  let interval = useRef<any>(null)

  const tickUpAnimation = useCallback(() => {
    let elapsedInner = timeElapsed
    const distanceToTravel = amount - elapsedInner
    interval.current = setInterval(
      () => {
        const strLen = distanceToTravel.toString().length
        const amountToTick = strLen >= 4 ? 111 : strLen === 3 ? 11 : 1
        elapsedInner += amountToTick
        setTimeElapsed((p) => Math.min(amount, p + amountToTick))
        if (elapsedInner >= amount) {
          clearInterval(interval.current)
        }
      },
      isVerySlow ? 200 : isSlow ? 100 : 20,
    )
  }, [amount, timeElapsed, isSlow, isVerySlow])

  useEffect(() => {
    if (amount >= 0) tickUpAnimation()
    return () => clearInterval(interval.current)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [amount, interval])

  return <>{timeElapsed.toLocaleString()}</>
}

export default TickUpNumber
